// extracted by mini-css-extract-plugin
export default {"wrapper":"error-view_wrapper__7gVH-","icon":"error-view_icon__acd0J","button":"error-view_button__b0O2H"};